"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDialogSurfaceContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useDialogSurfaceContextValues_unstable;
    }
});
function useDialogSurfaceContextValues_unstable(state) {
    const dialogSurface = true;
    return {
        dialogSurface
    };
}
